<template>
  <v-container class="no-margins">
    <EbookElementModalAdd
      v-if="showContent == 'addElement'"
      @cancelAdd="cancel"
      @changeClick="changeModalContent"
      @addElementClick="addElement"
      @addSubElementClick="addSubElement"
      :elem="elements"
      :isInstructor="isInstructor"
    ></EbookElementModalAdd>
    <EbookElementModalAddSubElement
      v-if="showContent == 'addSubElement'"
      @close="cancel"
      @changeClick="changeModalContent"
      @addElementClick="addElement"
      :selectedElement="selectedElement"
    ></EbookElementModalAddSubElement>
    <EbookElementModalJudgement
      v-if="showContent == 'elementJudgement'"
      @close="closeModal"
      @cancel="cancel"
      @deleted="deletedElement"
      @changeContentClick="changeModalContent"
      :elements="elements"
      :repDetail="reportDetail"
      :currentReport="currentReport"
      :isInstructor="isInstructor"
    ></EbookElementModalJudgement>

    <EbookElementModalChangeElement
      v-if="showContent == 'changeElement'"
      @close="closeModal"
      :elements="elements"
      :reportDetail="reportDetail"
    ></EbookElementModalChangeElement>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
// new steps
import EbookElementModalAdd from "@/components/Ebook/Apprentice/EbookElementModalAdd";
import EbookElementModalJudgement from "@/components/Ebook/Apprentice/EbookElementModalJudgement";
import EbookElementModalChangeElement from "@/components/Ebook/Apprentice/EbookElementModalChangeElement";
import EbookElementModalAddSubElement from "@/components/Ebook/Apprentice/EbookElementModalAddSubElement";

import NextButton from "@/components/Common/NextButton";
import BottomNav from "@/components/Application/BottomNav";
// @group Ebook
// Styled EbookElementModal component
export default {
  name: "EbookElementModal",

  props: {
    //is it showed
    show: {
      // `'String'`
      type: String,
      // The default value is: ` '' `
      default: "",
    },
    //is instructor
    isInstructor: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false,
    },
    //has any selected element
    selElement: {
      // `'Object'`
      type: Object,
      // The default value is: `{}`
      default: function () {
        return {};
      },
    },
    currentReport: Object,
  },
  data: () => ({
    search: "",
    modalAdd: true,
    showContent: "addElement",
    showElementChangeDialog: false,
    reportDetail: {},
    elements: [],
    selectedElement: {},
  }),

  components: {
    BottomNav,
    NextButton,
    EbookElementModalChangeElement,
    EbookElementModalAdd,
    EbookElementModalJudgement,
    EbookElementModalAddSubElement,
  },

  created() {
    this.init();
  },

  watch: {
    show() {
      this.showContent = this.show;
    },

    selElement() {
      if (this.show != "") {
        this.showContent = this.show;
      }
      this.reportDetail = this.selElement;
    },
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser", "isApprentice"]),
  },

  methods: {
    init() {
      if (this.show != "") {
        this.showContent = this.show;
      }
      this.reportDetail = this.selElement;

      if (this.isInstructor && this.currentReport) {
        this.getBook(this.currentReport.bookId);
      } else {
        this.getBook(Number(this.$route.params.id));
      }
    },
    /**
     * @vuese
     * Used to get specific book based on id
     * @arg the argument is a integer representing book id
     */
    getBook(id) {
      if (id > 0) {
        API.getBook(id)
          .then((res) => {
            if (res.data) this.elements = res.data.bookElements;
          })
          .catch((error) => {
            console.log("Error: " + error);
          });
      }
    },
    addSubElement(params) {
      this.showContent = params.show;
      this.selectedElement = params.selectedElement;
    },
    addElement(params) {
      if (params && params.subElement.id && params.subElement.id > 0) {
        this.reportDetail = {};
        this.reportDetail.subElement = params.subElement;
        this.reportDetail.subElement.element = {
          name: params.elementName,
        };
        this.showContent = params.show;
      }
    },
    /**
     * @vuese
     * Used to delete a book
     */
    deletedElement(id) {
      // Fire deletedElement
      // @arg The argument is a integer representing book id
      this.$emit("deletedElement", id);
    },

    changeModalContent(value) {
      this.showContent = value;
    },
    /**
     * @vuese
     * Used to close modal and emit report
     */
    closeModal() {
      this.showContent = "addElement";
      // Fire added
      // @arg The argument is a Object representing report detail
      this.$emit("added", this.reportDetail);
    },
    /**
     * @vuese
     * Used to cancel any operation
     */
    cancel() {
      this.$emit("close");
    },
  },
};
</script>
